<template>
  <div class="container page lottery">
    <van-nav-bar :title="lottery.name" class="nav-bar">
      <!-- <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template> -->
      <template #right>
        <!-- {{ lottery.name }} -->
        <!-- <div class="c_kk_u_m">{{ this.userInfo.money }}</div> -->
        <!-- <div class="right" @click="showRight">{{ $t('reservation.switching_window') }}</div>  -->
        <div class="right c_k_right" @click="showRight" v-if="userInfo.money">{{ userInfo.money }}</div>
        <img :src="lottery.ico" v-if="lottery.ico" class="c_kk_img" @click="toMine">
        <img src="/img/neww/userpic.png" class="c_kk_img" v-if="!lottery.ico" @click="toMine">
      </template>
    </van-nav-bar>
    <div class="record">
      <img src="/img/detail.png" @click="toVoteRecord" class="vote-record-icon" />
      <!-- <div class="period">
        
        <span class="period-number">{{ lottery.now_expect }}{{$t("lottery.period")}}</span>
        <div class="next-number">
          <van-count-down :time="time" @finish="check()" />
        </div>
      </div> -->
      <div class="info_c_h">
        <div class="m1">{{$t("q25")}}</div>
        <span class="p_number"> <span>{{ lottery.next_expect }}</span> {{$t("q26")}}</span>
        <div class="">
          <van-count-down class="c_time" format="mm:ss" :time="time" @finish="check()" />
        </div>

      </div>
      <div class="c_bt_m">
        <div class="left_b">
          <div class="hao">{{ lottery.now_expect }}{{$t("lottery.period")}}</div>
          <!-- <div class="bn">{{ sum }}</div> -->
          <div class="bn" :class="calcBg(size)">{{ size }}</div>
          <div class="bn r" :class="calcBg(double)">{{ double }}</div>
        </div>
        <div class="right_b"  @click="active ? active = false : active = true">
          <div class="r_c">{{$t("q27")}}</div>
          <van-icon name="arrow-down" :class="{ up: active, down: !active }"
            style="margin-left: auto;" />
        </div>
      </div>
      <!-- <div
        
        class="numberBox"
        style="
          background: rgba(0,0,0,.2);
          padding: 12px;
          margin-bottom: 10px;
          border-radius: 8px;
          display: flex;
          align-items: center;
        "
      >
        <div
          
          style="
            border-right: 4px solid rgb(249, 177, 231);
            padding: 0px 30px 0px 10px;
            color: rgb(255, 255, 255);
            font-weight: bold;
            font-size: 16px;
            text-align: center;
          "
        >
          <div >{{ lottery.now_expect}}</div>
          <div >{{ $t('reservation.voting_results') }}</div>
        </div>
        <div  class="resBox">
          <div  class="resItem">{{ sum }}</div>
          <div >
            <div
              
              class="ressquareBox"
              style="margin: 0px 0px 5px; min-width: 70px;"
            >
              {{ size }}
            </div>
            <div  class="ressquareBox" style="margin: 0px;">
              {{double}}
            </div>
          </div>
     
          <van-icon name="arrow-down"  :class="{ up: active,down:!active }" @click="active ? active = false : active = true" style="margin-left: auto;" />
        </div>
      </div> -->

    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="put_tit_r">{{ selectedCount > 0 ? $t('lottery.selected').replace('1', selectedCount) : $t('reservation.no_choose') }}</div>
        <div class="game">
          <div class="sumValueTwoSides">
            <div class="rectangle large" :class="{ active: choose[v.type] }" v-for="(v, key) in lottery_peilv_list"
              :key="key" @click="choosePlay(v.type, v.name)">
              <div class="c_u_item" :style="{ 'background': v.color }">

                <img :src="v.img" alt="">
                <div class="text_k">{{ v.name == 'big' ? rose : v.name == 'small' ? lily : v.name == 'one' ? fireworks : balloon }}</div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="activityGroup">
        <div class="activityTitleWrap">
          <span class="ac-title">{{$t("lottery.watch_live_vote")}}</span>
        </div>
        <div class="box1">
          <div class="chatList" ref="chatList">
            <div class="scroll-wrapper" :style="{ transform: `translateY(${scrollPosition}px)` }">
              <div class="profitCont" v-for="(v, key) in buyLotteryList" :key="key">
                <div class="Cont_item_top">
                  <div class="item_top_left">
                    {{$t("lottery.congratulations")}} {{ v.username }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="bottom-bar">
        <div class="wrapper_box" :class="'active'">
          <div class="part_show">
          <div class="put_tit_r">{{ selectedCount > 0 ? $t('lottery.selected').replace('1', selectedCount) : $t('reservation.no_choose') }}</div>
            <!-- <van-icon name="arrow-down" :class="{ up: !shopping, down: shopping }"
              @click="shopping ? (shopping = false) : (shopping = true)" /> -->
          </div>
          <div class="part_input">
            <span class="label">{{ $t("reservation.per_price") }}:</span>
            <div class="amount-wrapper">
              <!-- :placeholder="$t('reservation.price_place')" -->
              <van-field v-model="money" type="digit"  />

            </div>
          </div>
          <div class="sub_btn" @click="jiesuan()">
            {{ $t("reservation.submit") }}
          </div>
        </div>
        <!-- <div class="bar">
          <div class="left">
            <div class="item" @click="shopping ? (shopping = false) : (shopping = true)">
              <van-icon name="cart-o" class="jixuanico" color="#e6b98a" />

            </div>
            <div class="line"></div>
          </div>
          <div class="mid">
            <span class="text" style="margin-right: 6px;">{{ $t("reservation.available_balance") }}:</span>
            <span class="text num">{{ this.userInfo.money }}</span>

          </div>
          <div class="right" @click="jiesuan()">
            {{ $t("reservation.submit") }}
          </div>
        </div>
        <div class="wrapper" :class="{ active: shopping }">
          <div class="item">
            <span class="label">{{ $t("reservation.curr_choose") }}：</span>
            <div class="bet-number">{{ convertedShopchoose }}</div>
            <van-icon name="arrow-down" :class="{ up: !shopping, down: shopping }"
              @click="shopping ? (shopping = false) : (shopping = true)" />
          </div>
          <div class="item">
            <span class="label">{{ $t("reservation.per_price") }}</span>
            <div class="amount-wrapper">
              <van-field v-model="money" type="digit" :placeholder="$t('reservation.price_place')" />

            </div>
          </div>
        </div> -->
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <!-- <div class="head van-hairline--bottom">
            <p class="text">{{ $t("reservation.task_list") }}</p>
          </div> -->
          <ui class="list">
            <li v-for="(v, key) in formData" :key="key" class="lise-item van-hairline--bottom">
              <div class="main">
                <p class="bet-name">{{ v.name == 'big' ? rose : v.name == 'small' ? lily : v.name == 'one' ? fireworks : balloon }}</p>
                <p class="detail-text">
                  1{{ $t("reservation.note") }}X{{ money
                  }}{{ $t("reservation.unit") }}={{ money
                  }}{{ $t("reservation.ge") }}
                </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>
          <div class="sub-bar">
            <van-button class="item cancel-btn" type="default" @click="allClear()">{{ $t("reservation.clear_order")
              }}</van-button>
            <van-button class="item sub-btn" type="default" @click="doSub">{{
              $t("reservation.submit")
            }}</van-button>
          </div>
        </div>

      </van-popup>
      <van-popup v-model="active" position="bottom" :style="{ height: '60%' }" get-container="body">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="wrapper pop_wrapper">
            <!-- <div class="item">
              <div class="left font-weight">{{ $t("reservation.num") }}</div>
              <div class="right font-weight">
                {{ $t("reservation.win_num") }}
              </div>
            </div> -->
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="">
                  <span class="ballBox">{{ calcopencode0(v) }}</span>
                  <span class="ballBox">{{ calcopencode1(v) }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>


    <van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
      <div class="list">

        <div class="item" v-for="(i, index) in gameitemData" :key="index" @click="tabList(i.id, i.key)">
          <div>{{$t("q29")}}</div>
          <div style="margin: 15px 0 0 15px;">
            <div
              style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;">
              <van-image width="60" height="61" :src="i.ico" style="" />
            </div>

            <div style="font-size: 14px;">{{ i.name }}</div>
          </div>
        </div>


      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks: "",
      choose: {
        A: false,
        B: false,
        C: false,
        D: false,
        AB: false,
        AC: false,
        AD: false,
        BC: false,
        BD: false,
        CD: false,
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: {},
      buyLotteryList: [],
      scrollPosition: 0,
      itemHeight: 0,
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      ids: 11,
      keys: 5,
      gameitemData: [],
      userTimer:"",
      scrollTimer: null,
      fakeDataTimer: null
    };
  },
  mounted(){
    if(this.userTimer){
      clearInterval(this.userTimer);
      this.userTimer = ""
    }
    setInterval(()=>{
      this.getUserInfo()
    },10000)
  },
  beforeDestroy() {
    if(this.scrollTimer){
      clearInterval(this.scrollTimer);
    }
    if(this.userTimer){
      clearInterval(this.userTimer);
    }
    if(this.fakeDataTimer){
      clearInterval(this.fakeDataTimer);
    }
  },
  methods: {
    toMine() {
      this.$router.push("/Mine")
    },
    toVoteRecord() {
      this.$router.push("/GameRecord")
    },
    back() {
      return window.history.back();
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {

      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      console.log(type, name);
      console.log(this.choose)
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
        console.log(this.shopchoose, 'ssss')

      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            this.getBuyLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 10000);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          console.log(this.userInfo,"---477")
          if(this.userInfo.is_online != 1){
            localStorage.clear()
            this.$router.push({ path: '/Login' });
          }
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          let lottery_peilv_list = res.data;
          console.log(lottery_peilv_list, "lottery_peilv_list--508")
          let clist = [];
          let appItem = [
            { img: "/img/neww/1.gif", color: "#8948fb" },
            { img: "/img/neww/2.gif", color: "#ff6398" },
            { img: "/img/neww/3.gif", color: "#2196f3" },
            { img: "/img/neww/4.gif", color: "#ff7d73" },
          ]
          lottery_peilv_list.map((itemc, key) => {
            itemc = {
              ...itemc,
              ...appItem[key]
            }
            clist.push(itemc)
          })
          this.lottery_peilv_list = clist;

          console.log("lottery_peilv_list:", this.lottery_peilv_list);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          console.log("lottery_list:");
          console.log(res.data);
          this.getLotteryPeilv();
        }
      });
    },
    getBuyLotteryList() {
      this.$http({
        method: "get",
        url: "lottery_buy_list",
      }).then((res) => {
        if (res.code === 200) {
          this.buyLotteryList = this.generateFakeData(res.data);
          console.log("buyLotteryList:", this.buyLotteryList);
          this.$nextTick(() => {
            this.startAutoScroll();
            this.startFakeDataGenerator(res.data);
          });
        }
      });
    },
    generateFakeData(realData) {
      return realData || [];
    },
    startFakeDataGenerator(realData) {

      const betTypes = ['A', 'B', 'C', 'D'];
      const betAmounts = [10, 20, 50, 100, 200, 500];
      
      let realUsernames = [];
      if (realData && realData.length > 0) {
        const usernameSet = new Set(realData.map(item => item.username));
        realUsernames = Array.from(usernameSet);
      }
      
      const fakeUsernames = [
        'A****1', 'B****2', 'C****3', 'D****4', 'E****5',
        'F****6', 'G****7', 'H****8', 'I****9', 'J****0',
        'K****1', 'L****2', 'M****3', 'N****4', 'O****5',
        'P****6', 'Q****7', 'R****8', 'S****9', 'T****0',
        'U****1', 'V****2', 'W****3', 'X****4', 'Y****5', 'Z****6'
      ];
      
      let usernameIndex = 0;
      
      this.fakeDataTimer = setInterval(() => {
        let username;
        
        if (realUsernames.length > 0 && Math.random() > 0.8) {
          username = realUsernames[Math.floor(Math.random() * realUsernames.length)];
        } else {
          username = fakeUsernames[usernameIndex];
          usernameIndex = (usernameIndex + 1) % fakeUsernames.length;
        }
        
        const randomType = betTypes[Math.floor(Math.random() * betTypes.length)];
        const randomMoney = betAmounts[Math.floor(Math.random() * betAmounts.length)];
        const timestamp = Date.now();
        
        const newBet = {
          username: username,
          type: randomType,
          money: randomMoney,
          mid: randomType + '*' + randomMoney,
          timestamp: timestamp
        };
        
        const recentUsernames = this.buyLotteryList.slice(0, 10).map(item => item.username);
        const isRecentDuplicate = recentUsernames.includes(username);
        
        if (!isRecentDuplicate) {
          this.buyLotteryList.unshift(newBet);
          this.scrollPosition = 0;
          
          if (this.buyLotteryList.length > 30) {
            this.buyLotteryList = this.buyLotteryList.slice(0, 30);
          }
        }
      }, 1000);
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitemData = res.data;
        console.log(this.gameitemData, 'gameitemData')
      })
    },
    tabList(id, key) {
      this.ids = id
      this.keys = key
      this.showModel = false
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
      this.getBuyLotteryList();
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        console.log(lanng,"lanng---552")
        if (res.code === 200) {
          if (
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          this.lottery = res.data;
          console.log(this.lottery, 'qweqweqw')
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(
              this.$t("reservation.prize_succ") + this.lottery.now_expect
            );
          }

          this.sum =
            res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          console.log(this.sum, 'sum')
          if (this.sum >= 11 && this.sum <= 18) {
            this.size = this.$t('lottery.rose')

          } else if (this.sum >= 3 && this.sum <= 10) {
            this.size = this.$t('lottery.lily')

          }
          if (this.sum % 2 === 0) {
            this.double = this.$t('lottery.balloon');

          } else {
            this.double = this.$t('lottery.fireworks');


          }
        }
        console.log(this.lottery, 9900)
      });
    },
    calcopencode0(data){
           var sum =
           data.opencode[0] + data.opencode[1] + data.opencode[2];
          if (sum >= 11 && sum <= 18) {
           return this.$t('lottery.rose')
          } else if (sum >= 3 && sum <= 10) {
            return this.$t('lottery.lily')
          }
    },
        calcopencode1(data){
           var sum =
           data.opencode[0] + data.opencode[1] + data.opencode[2];
      if (sum % 2 === 0) {
            return this.$t('lottery.balloon');

          } else {
            return this.$t('lottery.fireworks');


          }
    },
    calcBg(el) {
      if (el == this.$t('lottery.rose')) {
        return 'd'
      } else
        if (el == this.$t('lottery.lily')) {
          return 'x'
        } else
          if (el == this.$t('lottery.fireworks')) {
            return 'v'
          } else
            if (el == this.$t('lottery.balloon')) {
              return 'r'
            } else {
              return 'r'
            }
    },
    startAutoScroll() {
      this.$nextTick(() => {
        const chatList = this.$refs.chatList;
        if(chatList) {
          const profitCont = chatList.querySelector('.profitCont');
          if(profitCont) {
            this.itemHeight = profitCont.offsetHeight + 10;
          }
        }
      });
    },
    calcBgLs(n1, n2, n3, type) {
      let zhi = n1 + n2 + n3;
      if (type == 'type1') {
        if (zhi >= 11 && zhi < 18) {
          return 'd'
        } else {
          return 'x'
        }
      }
      if (type == 'type2') {
        if (zhi % 2 == 0) {
          return 'v'
        } else {
          return 'r'
        }
      }
    },
  },

  created() {
    this.getUserInfo();
    this.getGameItem()
    this.getLotteryInfo();
    this.getLotteryList();
    this.rose = this.$t('lottery.rose');
    this.lily = this.$t('lottery.lily');
    this.balloon = this.$t('lottery.balloon')
    this.fireworks = this.$t('lottery.fireworks')

  },
  computed: {
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };

      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    },
    selectedCount() {
      return Object.values(this.choose).filter(value => value === true).length;
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

/* 基础样式 */
.c_kk_img {
  height: 56px;
  width: 56px;
  border-radius: 50%;
  border: 2px solid #766350;
  margin-left: 20px;
}
.info_c_h {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  color: #fff;
  padding: 60px 30px 10px;
  .m1 {
    padding-bottom: 16px;
  }
  .p_number {
    padding-bottom: 10px;
    font-size: 30px;
    span {
      font-weight: bold;
      font-size: 36px;
    }
  }
}
.c_bt_m {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 10px 0 30px;
  .left_b {
    display: inline-flex;
    align-items: center;
    color: #fff;
    .hao{
      font-size: 24px;
    }
    .bn {
      padding: 0 10px;
      border-radius: 30px;
      margin-left: 10px;
      font-size: 20px;
      &.d {background: #8948fb;}
      &.x {background: #ff6398;}
      &.v {background: #2196f3;}
      &.r {background: #ff7d73;}
    }
  }
  .right_b {
    display: inline-flex;
    align-items: center;
    .r_c {font-size: 24px;margin-right: 6px;color: #fff;}
    .up,.down{font-size: 28px;}
  }
}
.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #e6b98a;
  font-size: 36px;
  border-radius: 10px;
  line-height: 60px;
}
.lottery {
  background: #1f1c1f  no-repeat;
  background-size: 94% auto;
  background-position: center 120px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.lottery .van-nav-bar {
  background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%);
}
.record {padding: 0 20px;z-index: 1;position: relative; background: linear-gradient(270deg,#7030a0,#b775e9)}
.vote-record-icon {position: absolute; right: 30px; top: 30px; z-index: 10; font-size: 40px; cursor: pointer;
width: 40px;
height: 40px;
}
.van-count-down {
  color: #fff;
  font-size: 28px;
  margin-top: 10px;
  float: right;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 6px;
}
.van-icon {font-size: 40px;}
.down {transition: all 0.5s;color: #fff;}
.up {transform: rotate(180deg);transition: all 0.5s;color: #fff;}

/* --------- 核心修复：内容区（留底，防止被底部栏遮挡） --------- */
.wrapper {
margin-top: 20px;
  position: relative;
  flex: 1;
  z-index: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* 关键：给底部吸底栏留出空间，内容不被遮挡 */
  padding-bottom: 320px !important;
}

/* 选项容器 */
.options-bar {
  border: 1px solid #766350;
  border-radius: 16px;
  background: linear-gradient(120deg, #212121, #313131);
  margin: 30px 20px;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 414px) {
    min-height: 280px;
  }
  
  @media (max-width: 375px) {
    min-height: 240px;
  }
}
.put_tit_r {
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  margin: 20px;
  &::before {
    content: "";
    width: 8px;
    height: 30px;
    background: linear-gradient(to right, #ff7a8d 0%, #ff4d67 100%);
    position: absolute;
    left: 0;
    top: 6px;
  }
}
.options-bar .game {
  flex: 1;
  overflow: visible;
  min-height: 150px;
  
  @media (max-width: 414px) {
    min-height: 130px;
  }
  
  @media (max-width: 375px) {
    min-height: 110px;
  }
}

/* --------- 核心：sumValueTwoSides 强制显示 --------- */
.sumValueTwoSides {
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  gap: 5px;
  min-height: 180px;
  visibility: visible !important;
  opacity: 1 !important;
  .c_u_item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 5px;
    height: 100%;
    border-radius: 10px;
    gap: 3px;
    img {width: 40px;height: auto;}
  }
  
  @media (max-width: 414px) {
    gap: 4px;
    padding: 4px;
    min-height: 160px;
    .c_u_item {
         height: 100%;
      img {width: 35px;height: auto;}
    }
  }
  
  @media (max-width: 375px) {
    gap: 3px;
    padding: 3px;
    min-height: 140px;

    .c_u_item {
    height: 100%;
      img {width: 32px;height: auto;}
    }
  }
}
.rectangle {overflow: visible;}
.rectangle.large {
  width: 44% !important;
  height: auto !important;
  background: #fff;
  box-shadow: 0 4px 24px 0 rgba(0,0,0,.1);
  margin: 0 0 3% 3%;
  border-radius: 20px;
  color: #fff;
  
  @media (max-width: 414px) {
    width: 44% !important;
    margin: 0 0 3% 3%;
  }
  
  @media (max-width: 375px) {
    width: 43% !important;
    margin: 0 0 2% 2%;
  }
  &.active {
    position: relative;
    &::after {
      content: "";
      background: url(/img/neww/ico_yes.png) no-repeat;
      background-size: 50px auto;
      width: 60px;
      height: 60px;
      position: absolute;
      bottom: 2px;
      right: 2px;
      display: block;
    }
    .c_u_item {
      background-color: #212121 !important;
      color: #f3c7a2 !important;
      border: 4px solid #766350;

    }
  }
}

.rectangle.large .wrapper {
  padding-bottom: 100%;
}

.rectangle .wrapper .content .name-text.large {
  font-size: 28px;
  
  @media (max-width: 414px) {
    font-size: 24px;
  }
  
  @media (max-width: 375px) {
    font-size: 20px;
  }
}

.rectangle .wrapper .content .name-text {
  color: #7d7c7c;
  
  @media (max-width: 414px) {
    font-size: 18px;
  }
  
  @media (max-width: 375px) {
    font-size: 16px;
  }
}

.rectangle .wrapper .content .odd-text.large {
  font-size: 25px;
  margin-top: -30px;
  
  @media (max-width: 414px) {
    font-size: 20px;
  }
  
  @media (max-width: 375px) {
    font-size: 18px;
  }
}

.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}

/* --------- 终极修复：bottom-bar 永久吸底 --------- */
.bottom-bar {
  position: fixed !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 999 !important;
  height: auto;
}
/* 底部弹窗默认隐藏，不遮挡内容 */
.wrapper_box{
  background: linear-gradient(120deg,#212121,#313131);
  transform: translateY(100%);
  padding-bottom: 112px;
  transition: transform 0.3s ease;
  &.active{
    transform: translateY(0);
  }
  .down{color: #766350;}
  .part_show{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  .part_input{
    display: flex;
    justify-content: center;
    align-items: center;
    .label{color: #c5c5c5;font-size: 28px;}
    .amount-wrapper{
      width: 30%;
      .van-cell{
        border: 1px solid #766350;
        background: linear-gradient(120deg,#212121,#313131);
        border-radius: 60px;
        padding: 4px 20px;
      }
    }
  }
}

.van-cell {
  font-size: 30px;
  line-height: 50px;
  background-color: rgba(0, 0, 0, .5);
  margin-left: 20px;
}

.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}

::v-deep .van-field__control {
  color: #e6b98a;
}

.sub_btn{
    background: linear-gradient(180deg,#efcba7,#dcab76);
    margin: 20px 70px;
    text-align: center;
    padding: 16px 0;
    border-radius: 10px;
  }
.wrapper .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.333vw 0;
}

.wrapper .item .left {
    width: 26.667vw;
    font-size: 3.2vw;
    text-align: center;
    font-weight: 500;
    color: #7030a0;
}
.font-weight{
    font-weight: 700 !important;
}
.wrapper .item .right {
    flex: 1;
    display: flex;
    font-size: 3.2vw;
    justify-content: center;
    overflow: hidden;
    color: #7030a0;
}
/* 剩余样式（不影响布局，保留原有效果） */
.pop_wrapper {border: 1px solid #ffc3cb;margin: 16px;padding: 0 10px;}
.middle {
  border-radius: 16px;
  padding: 0 16px;
  color: #fff;
  height: 6vw;
  line-height: 6vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  margin-right: 30px;
  &.d {background: #8948fb;}
  &.x {background: #ff6398;}
  &.v {background: #2196f3;}
  &.r {background: #ff7d73;}
}
.ballBox {color: #e6b98a;font-weight: 700;margin-right: 8px;font-size: 5vw;}
.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 2.667vw 4vw;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 90vw;
  height: 120vw;
  max-height: 80%;
  z-index: 10;
  background-color: #fff;
  border-radius: 4vw;
}
.confirm-order-modal .head {
  position: relative;
  height: 10.667vw;
}
.confirm-order-modal .head .text {
  padding: 0 2.667vw;
  height: 4vw;
  line-height: 1.333vw;
  text-align: center;
  font-size: 4.667vw;
  font-weight: 500;
  color: #7030a0;
}
.list {
  flex: 1;
  padding: 0 1.333vw;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.list .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1.333vw 0;
  color: #ff253f;
}
.list .item .main {
  flex: 1;
  overflow: hidden;
}
.list .item .bet-name {
  color: #ff253f;
  font-size: 4.667vw;
  font-weight: 500;
  line-height: 0;
  word-wrap: break-word;
  word-break: break-all;
}
.list .item .detail-text {
  line-height: 0;
  font-size: 3.333vw;
  color: #979799;
}
.list .item .van-icon {
  color: #ff253f;
  font-size: 5vw;
  padding: 1.333vw;
}
.sub-bar {
  display: flex;
  align-items: center;
  margin-top: 4vw;
  justify-content: space-around;
}
.sub-bar .item {
  min-width: 40%;
  height: 10.667vw;
  text-align: center;
  box-sizing: border-box;
  border-radius: 6.667vw;
  font-size: 4.667vw;
  font-weight: 500;
}
.sub-bar .item.cancel-btn {
  border: .267vw solid #979799;
  color: #979799;
  background-color: #fff;
}
.sub-bar .item.sub-btn {
  background: linear-gradient(90deg,#7030a0,#7030a0);
  color: #fff;
  border: 0;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-popup {
  position: absolute;
}

::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}

::v-deep .van-popup--top {
  top: -1px;
}

::v-deep .van-popup--bottom {
  bottom: 0;
  top: auto !important;
  max-height: 60vh;
}

::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}

.activityGroup {
  margin: 20px;
  background: #1f1c1f;
  border-radius: 10px;
  padding: 15px;
}

.activityTitleWrap {
  padding: 10px 0;
  border-bottom: 1px solid #313131;
  margin-bottom: 10px;
}

.ac-title {
  color: #e6b98a;
  font-size: 28px;
  font-weight: bold;
}

.box1 {
  min-height: 500px;
  overflow: hidden;
  position: relative;
}
.scroll-wrapper {
  transition: transform 10s ease-in;
  overflow: hidden;
}
.chatList {
  display: flex;
  flex-direction: column;
}

.profitCont {
  background: #2a2a2a;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}

.Cont_item_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item_top_left {
  color: #c5c5c5;
  font-size: 24px;
  flex: 1;
}

.item_top_right {
  color: #e6b98a;
  font-size: 24px;
  font-weight: bold;
}
</style>
